module.exports = __webpack_public_path__ + "videos/hero-mobile_en.117af48.mp4";